import React from 'react';

export const GibsonStratumLogo = ({ className = "", size = 32 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background hexagon shape */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#10B981" />
        </linearGradient>
        <linearGradient id="glowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#34D399" />
        </linearGradient>
      </defs>
      
      {/* Outer hexagon frame */}
      <path
        d="M32 4L56 18V46L32 60L8 46V18L32 4Z"
        fill="url(#logoGradient)"
        stroke="url(#glowGradient)"
        strokeWidth="2"
      />
      
      {/* Inner circuit lines */}
      <path
        d="M32 12L48 22V42L32 52L16 42V22L32 12Z"
        fill="none"
        stroke="rgba(255,255,255,0.3)"
        strokeWidth="1"
      />
      
      {/* G letter stylized as circuit/shield */}
      <path
        d="M24 26C24 22.6863 26.6863 20 30 20H36C37.1046 20 38 20.8954 38 22V24H32C30.8954 24 30 24.8954 30 26V38C30 39.1046 30.8954 40 32 40H36C37.1046 40 38 39.1046 38 38V34H34V30H42V38C42 41.3137 39.3137 44 36 44H30C26.6863 44 24 41.3137 24 38V26Z"
        fill="white"
      />
      
      {/* S overlay as data stream */}
      <path
        d="M34 28L40 28"
        stroke="#bef264"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M34 32L38 32"
        stroke="#bef264"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Corner nodes */}
      <circle cx="32" cy="12" r="2" fill="#bef264" />
      <circle cx="48" cy="22" r="2" fill="#60a5fa" />
      <circle cx="48" cy="42" r="2" fill="#60a5fa" />
      <circle cx="32" cy="52" r="2" fill="#bef264" />
      <circle cx="16" cy="42" r="2" fill="#60a5fa" />
      <circle cx="16" cy="22" r="2" fill="#60a5fa" />
    </svg>
  );
};

export const GibsonStratumLogoAlt = ({ className = "", size = 32 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGradientAlt" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="50%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#10B981" />
        </linearGradient>
      </defs>
      
      {/* Shield base */}
      <path
        d="M32 6L54 16V34C54 44.5 44.5 54 32 58C19.5 54 10 44.5 10 34V16L32 6Z"
        fill="url(#logoGradientAlt)"
      />
      
      {/* Inner shield */}
      <path
        d="M32 12L48 20V34C48 41.5 41.5 49 32 52C22.5 49 16 41.5 16 34V20L32 12Z"
        fill="#030712"
      />
      
      {/* GS Monogram */}
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fill="white"
        fontSize="18"
        fontWeight="bold"
        fontFamily="'Outfit', sans-serif"
      >
        GS
      </text>
      
      {/* Circuit dots */}
      <circle cx="32" cy="12" r="2" fill="#bef264" />
      <circle cx="48" cy="20" r="1.5" fill="#60a5fa" />
      <circle cx="16" cy="20" r="1.5" fill="#60a5fa" />
    </svg>
  );
};

export default GibsonStratumLogo;
